/**
 * Search utilities - migrated to use backend API
 */

import type { AcademyCourse } from "@/types";
import { mockCourses } from "./mock-data";
import { Class } from "@/types";
import { api } from "@/lib/api";

export function searchCourses(query: string): AcademyCourse[] {
  if (!query || query.trim().length === 0) {
    return [];
  }

  const searchTerm = query.toLowerCase().trim();

  return mockCourses.filter((course) => {
    const titleMatch = course.title.toLowerCase().includes(searchTerm);
    const descriptionMatch = (course.description ?? "").toLowerCase().includes(searchTerm);
    const categoryMatch = (course.category ?? "").toLowerCase().includes(searchTerm);

    return titleMatch || descriptionMatch || categoryMatch;
  });
}

/**
 * Search classes (similar to searchCourses but for the new classes system)
 */
export async function searchClasses(query: string): Promise<Class[]> {
  if (!query || query.trim().length === 0) {
    return [];
  }

  try {
    const data = await api<Class[]>(`/classes/search?q=${encodeURIComponent(query)}`);
    return data || [];
  } catch (error) {
    console.error("Error searching classes:", error);
    return [];
  }
}

export interface ProfileSearchResult {
  id: string;
  username: string | null;
  first_name: string | null;
  last_name: string | null;
  image_url: string | null;
}

export async function searchProfiles(query: string): Promise<ProfileSearchResult[]> {
  if (!query || query.trim().length === 0) {
    return [];
  }

  try {
    const data = await api<ProfileSearchResult[]>(`/users/search?q=${encodeURIComponent(query)}`);
    return data || [];
  } catch (error) {
    console.error("Error searching profiles:", error);
    return [];
  }
}
